var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('list-filter', {
    staticClass: "mb-30px mb-md-68px",
    attrs: {
      "data-aos": "fade-up"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._l(_vm.items, function (item) {
    return _c('v-col', {
      key: item._id,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('v-card', {
      staticClass: "list-item v-card--none-active-bg plus-btn-card",
      attrs: {
        "tile": "",
        "flat": "",
        "color": "transparent"
      },
      on: {
        "click": function ($event) {
          _vm.selectedVideoId = item.videoId;
        }
      }
    }, [_c('div', {
      staticClass: "list-item__thumb-wrap"
    }, [_c('v-img', {
      staticClass: "list-item__thumb w-100",
      attrs: {
        "src": item.thumbnail,
        "max-width": "464",
        "aspect-ratio": 16 / 9
      }
    })], 1), _c('div', {
      staticClass: "py-18px py-md-36px"
    }, [_c('u-txt-default', {
      staticClass: "txt--sm txt--light line-height-14"
    }, [_c('v-row', {
      staticClass: "row--xxs",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('p', [_vm._v(_vm._s(item.label))])]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    })], 1)], 1), _c('u-tit-medium', {
      staticClass: "tit--sm line-height-14 text-truncate-2 mt-8px mt-md-16px"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.title) + " ")])], 1)])], 1);
  }), _vm.showsMore ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-progress-circular', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: _vm.onIntersectMore,
      expression: "onIntersectMore"
    }],
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1) : _vm._e()], 2), _c('v-bottom-sheet', {
    attrs: {
      "value": !!_vm.selectedVideoId,
      "eager": "",
      "fullscreen": "",
      "content-class": "mw-100 h-100",
      "max-width": "100%",
      "width": "100%"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "x-large": "",
      "absolute": "",
      "top": "",
      "right": "",
      "icon": "",
      "text": "",
      "color": "white"
    },
    on: {
      "click": function ($event) {
        _vm.selectedVideoId = null;
      }
    }
  }, [_c('icon-close')], 1), !!_vm.selectedVideoId ? _c('v-responsive', {
    attrs: {
      "max-width": "1440",
      "aspect-ratio": 1440 / 810
    }
  }, [_c('iframe', {
    staticClass: "w-100 h-100 d-block",
    attrs: {
      "src": 'https://www.youtube.com/embed/' + _vm.selectedVideoId,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })]) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }